class PivotWidget extends ReportWidget {
    override widgetType = WidgetType.Pivot;

    static readonly searchBoxHeight = 31;
    static readonly emptyGroupName = "EmptyGroupName";
    readonly functionTypeOptions = ["none", "none", "none", "none", "percentOfRowTotal", "percentOfRowGrandTotal", "percentOfColumnTotal", "percentOfColumnGrandTotal", "absoluteVariation", "percentVariation", "none"];

    constructor(container: any, tab: WorkbookTab, $reportContent, dashboardWidget: DashboardWidget) {
        super(container, tab, $reportContent, dashboardWidget);
    }

    override setResult(result) {
        super.setResult(result);

        if (this.result.drilldownId > 0 && this.result.columns.filter(x => x.isGrouping).length === 0) {
            //Create a grouped column when drilling down to design the pivot similar to a report
            this.result.columns.splice(0, 0, {
                isGrouping: true,
                name: PivotWidget.emptyGroupName,
                calculateCellValue: function (rowData) {
                    return "";
                },
                groupColumns: [],
                area: "column"
            } as any)
            this.itemConfig.pivotConfig.showColumnGrandTotals(false);
        }
    }

    override setup() {
        super.setup();
        let self: PivotWidget = this;

        let sortMetric = this.result.columns.find((x) => { return x.isMetric && x.sortOrder; });
        let sortMetricIdx = undefined;
        if (sortMetric) {
            sortMetricIdx = this.result.columns.indexOf(sortMetric);
        }

        let dependentColumns = [];
        const maxGroupId = Math.max(...self.result.columns.map(item => item.groupId));

        //Using 'forEach' because the 'for of' was crashing the page
        this.result.columns.forEach(function (this: PivotWidget, field) {
            field.sortBy = undefined;
            if (field.isGrouping) {
                field.visible = true;
                field.groupColumns.forEach(function (groupColumn) {
                    if (groupColumn.sortOrder) {
                        field.sortBy = "value";
                        field.sortOrder = groupColumn.sortOrder;
                    }
                });

                if (sortMetric && field.area === "row") {
                    field.sortBySummaryField = sortMetricIdx;
                    field.sortBySummaryPath = [];
                    field.sortOrder = sortMetric.sortOrder;
                }
            }
            else if (field.isMetric) {

                if (field.groupingType === GroupingTypeEnum.WSUM ||
                    ((field.groupingType === GroupingTypeEnum.DSUM || field.groupingType === GroupingTypeEnum.WDSUM) && field.calculateTotals === CalculateTotalsEnum.UseFormula) ||
                    field.comparisonType >= ComparisonTypeEnum.Variation ||
                    field.functionType === FunctionTypeEnum.AccumulatedAll /*&& field.groupingType !== GroupingTypeEnum.SUM*/) {
                    field.summaryType = "custom";
                    delete field.dataField;
                    if (field.functionType === FunctionTypeEnum.AccumulatedAll || field.comparisonType >= ComparisonTypeEnum.Variation) {
                        field.calculateCustomSummary = function (options) {
                            options.column = this;
                            self.calculateCustomSummary(options);
                        }
                    }
                }

                if (field.functionType === FunctionTypeEnum.Rank) {
                    field.showGrandTotals = false;
                    field.calculateSummaryValue = function (cell) {
                        if (cell.parent("row") == null)
                            return;

                        let topValue = cell.value(`${field.indexBase}`, true);
                        if (topValue == 25 || true) {
                            let children = cell.children("row");
                            if (children.length != 0)
                                return;
                        }
                        return topValue;
                    };
                }

                if (field.groupingType === GroupingTypeEnum.TSUM) {
                    let groupColumnCount = this.result.columns.filter(x => x.isGrouping && x.area === "column").length;
                    field.calculateSummaryValue = function (cell) {
                        let isTotal = false;
                        let parent = cell.parent("column");
                        for (var i = 0; i < groupColumnCount - 1; i++) {
                            if (parent) {
                                parent = parent.parent("column");
                            }
                        }
                        isTotal = !parent;

                        if (isTotal) { // grand total | total
                            return cell.children().map(c => c.value(true)).reduce(
                                (acc, curr) => acc + (curr || 0), 0
                            );
                        } else
                            return cell.value();
                    }
                }

                if (field.groupingType === GroupingTypeEnum.WSUM && field.functionType !== FunctionTypeEnum.AccumulatedAll) {

                    dependentColumns.push({
                        caption: `${field.indexBase} TOP`,
                        dataField: `${field.indexBase}`,
                        dataType: 'number',
                        summaryType: 'sum',
                        area: 'data',
                        visible: false,
                        runningTotal: field.functionType === FunctionTypeEnum.Accumulated ? 'column' : '',
                    });

                    dependentColumns.push({
                        caption: `${field.indexBottom} BOTTOM`,
                        dataField: `${field.indexBottom}`,
                        dataType: 'number',
                        summaryType: 'sum',
                        area: 'data',
                        visible: false,
                        runningTotal: field.functionType === FunctionTypeEnum.Accumulated ? 'column' : '',
                    });

                    field.calculateSummaryValue = function (cell) {
                        if (field.comparisonType >= ComparisonTypeEnum.Variation) {
                            let valueTop = cell.value(`${field.indexBase}`, true)
                            let valueTopComparison = cell.value(`${field.indexComparison}`, true)
                            let valueBottom = cell.value(`${field.indexBottom}`, true);
                            let valueBottomComparison = cell.value(`${field.indexBottomComparison}`, true);

                            let value = valueBottom === 0 ? 0 : valueTop / valueBottom;
                            let valueComparison = valueBottomComparison === 0 ? 0 : valueTopComparison / valueBottomComparison;
                            let valueVariation = value - valueComparison;

                            if (field.comparisonType === ComparisonTypeEnum.PercentageVariation) {
                                valueVariation = valueComparison === 0 ? 0 : valueVariation / valueComparison;
                            }

                            return valueVariation;
                        }

                        let topValue = cell.value(`${field.indexBase}`, true);
                        let bottomValue = cell.value(`${field.indexBottom}`, true);

                        if (field.functionType === FunctionTypeEnum.Accumulated) {
                            let stackTopValue = topValue || 0;
                            let stackBottomValue = bottomValue || 0;
                            let prevCell = cell.prev("row");
                            while (prevCell) {
                                stackTopValue += prevCell.value(`${field.indexBase}`, true) || 0;
                                stackBottomValue += prevCell.value(`${field.indexBottom}`, true) || 0;
                                prevCell = prevCell.prev("row");
                            }

                            return stackBottomValue === 0 ? 0 : stackTopValue / stackBottomValue;
                        }

                        let wsumValue = bottomValue === 0 ? 0 : topValue / bottomValue;
                        return wsumValue;
                    };
                }

                if ((field.groupingType === GroupingTypeEnum.DSUM || field.groupingType == GroupingTypeEnum.WDSUM) && field.calculateTotals === CalculateTotalsEnum.UseFormula) {
                    field.calculateSummaryValue = function (cell) {
                        let formula = field.formulaTop;
                        for (const dColumn of field.dependentColumns) {
                            let dColumnValue = 0;

                            if (dColumn.dataField === undefined && field.summaryType === "custom") {
                                if (dColumn.calculateSummaryValue) {
                                    dColumnValue = dColumn.calculateSummaryValue(cell)
                                }
                                else {
                                    dColumnValue = cell.value(`${dColumn.caption}`, true);
                                }
                            }
                            else {
                                if (dColumn.groupingType === GroupingTypeEnum.WSUM) {
                                    let topValue = cell.value(`${dColumn.indexBase}`, true);
                                    let bottomValue = cell.value(`${dColumn.indexBottom}`, true);
                                    dColumnValue = bottomValue === 0 ? 0 : topValue / bottomValue;
                                }
                                else {
                                    dColumnValue = cell.value(`${dColumn.indexBase}`, true);
                                }
                            }

                            if (dColumnValue === undefined)
                                dColumnValue = 0;

                            formula = formula.replaceAll(`[${dColumn.indexBase}]`, dColumnValue);
                        }

                        let totalValue = eval(formula);
                        return totalValue;
                    };
                }

                if (field.functionType > FunctionTypeEnum.AccumulatedAll) {
                    field.summaryDisplayMode = this.functionTypeOptions[field.functionType];
                }

                if (field.groupingType === GroupingTypeEnum.SUM && field.functionType === FunctionTypeEnum.Accumulated) {
                    field.runningTotal = 'column';
                }

                //if (field.groupingType === GroupingTypeEnum.SUM && field.functionType === FunctionTypeEnum.AccumulatedAll) {
                //    field.runningTotal = 'column';
                //    field.allowCrossGroupCalculation = true;;
                //}

                //if (field.groupingType === GroupingTypeEnum.WSUM && field.functionType === FunctionTypeEnum.AccumulatedAll) {
                //    field.runningTotal = 'column';
                //    field.allowCrossGroupCalculation = true;;
                //}
            }

            if (self.itemConfig.pivotConfig.separateFields() && (field.area === "row" || field.area === "column")) {
                let groupedFields = self.result.columns.filter(x => !x.isMetric && x.visible && x.area === field.area && x.groupId == field.groupId);
                if (field.groupId === maxGroupId || (groupedFields.length && groupedFields[0] !== field)) {
                    field.showTotals = false;
                }
            }

            if (field.area === "row") {
                field.expanded = workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting ? self.itemConfig.expandAllRowsPrinting() : self.itemConfig.expandAllRows();
                field.wordWrapEnabled = false;
            }
            else if (field.area === "column") {
                field.expanded = workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting ? self.itemConfig.pivotConfig.expandAllColumnsPrinting() : self.itemConfig.pivotConfig.expandAllColumns();
            }
        }.bind(this));

        for (const depColumn of dependentColumns) {
            this.result.columns.push(depColumn);
        }

        if (this.result.columns.filter(x => x.area === "data").length === 1) {
            //Add a fake column to show the metric column header 
            this.result.columns.push({
                dataField: "pvt-fake",
                area: "data",
                visible: false
            } as any);
        }

        this.result.searchBox = this.result.gridContainer.siblings(".pivotGridSearchBox").dxTextBox(this.getSearchBoxConfig()).dxTextBox("instance");

        let pivotConfig = this.getPivotConfig();
        this.result.gridContainer.dxPivotGrid(pivotConfig);
        this.result.pivotGrid = this.result.gridContainer.dxPivotGrid('instance');
    }

    private getSearchBoxConfig() {
        let self: PivotWidget = this;
        return {
            valueChangeEvent: "keyup",
            mode: 'search',
            width: 160,
            placeholder: "Search...",
            visible: !workbook.workbookConfig.isPrinting && !workbook.workbookConfig.isExcelPrinting && this.itemConfig.enableSearchBox(),
            onValueChanged: function (e) {
                let pivotSource = self.result.pivotGrid.getDataSource();
                let filters = [];
                self.result.columns.forEach(function (c) {
                    if (c.dataField && !c.isMetric) {
                        if (filters.length > 0) {
                            filters.push("or");
                        }
                        filters.push([c.dataField, "contains", e.value]);
                    }
                });

                pivotSource.filter(filters);
                pivotSource.reload();
            }
        };
    }
    private getPivotConfig() {
        let collapseRows = [];
        let self: PivotWidget = this;
        let firstOnContentReady: boolean = true;

        return {
            allowExpandAll: true,
            allowSortingBySummary: true,

            allowFiltering: true,
            headerFilter: {
                search: {
                    enabled: true,
                },
            },
            fieldPanel: {
                allowFieldDragging: false,
                showFilterFields: false,
                showDataFields: false,
                visible: !workbook.workbookConfig.isPrinting && !workbook.workbookConfig.isExcelPrinting && this.itemConfig.enableFilterPanel(),
            },

            wordWrapEnabled: false,
            showBorders: this.itemConfig.glReport() ? false : true,

            showColumnGrandTotals: this.itemConfig.pivotConfig.showColumnGrandTotals(),
            showColumnTotals: this.itemConfig.pivotConfig.showColumnTotals(),
            showRowGrandTotals: this.itemConfig.pivotConfig.showRowGrandTotals(),
            showRowTotals: this.itemConfig.pivotConfig.showRowTotals(),

            allowSorting: true,
            dataFieldArea: this.itemConfig.pivotLayout() === PivotLayoutEnum.Horizontal ? "column" : "row",
            fieldChooser: {
                enabled: false,
                height: 400,
            },
            texts: {
                grandTotal: this.itemConfig.grandTotalText(),
                total: `${this.itemConfig.subTotalText()} {0}`
            },
            encodeHtml: false,
            rowHeaderLayout: this.itemConfig.glReport() ? 'standard' : this.itemConfig.pivotConfig.rowHeaderLayoutPivot() === 0 ? 'tree' : 'standard',
            dataSource: {
                fields: this.result.columns,
                store: this.result.result,
            },
            height: this.getPivotHeight(), //When sending the report as excel by email, we need to set the height for the scrolling.mode works
            width: workbook.workbookConfig.isExcelPrinting ? 200 : undefined, //When sending the report as excel by email, we need to set the width for the scrolling.mode works
            scrolling: {
                mode: workbook.workbookConfig.isPrinting && !workbook.workbookConfig.isExcelPrinting ? 'standard' : 'virtual',
                useNative: false
            },
            onCellPrepared: function (e) {
                const enableDrawIconSelectRow = self.itemConfig.enableRowSelection();
                const { cell } = e;
                cell.area = e.area;
                e.cellElement.css("font-size", self.itemConfig.fontSize());

                if (self.itemConfig.glReport()) {
                    e.cellElement.css("background-color", "#FFFFFF !important").css("color", "#000000");
                    //e.cellElement.children().each(function () {
                    //    $(this).css("background-color", "#FFFFFF !important").css("color", "#000000");
                    //});
                }

                if (PivotWidget.isDataCell(cell) || PivotWidget.isTotalCell(cell)) {
                    let field = PivotWidget.getField(e.component, cell);
                    if (field && field.isMetric && e.area !== "column") {
                        e.cellElement.css("text-align", field.alignment).css("vertical-align", "middle");
                        if (field.hasFormattingRule) {
                            if (cell.value !== undefined && !isNaN(cell.value)) {
                                e.cellElement.empty();
                                self.applyFormattingRuleCell(e.cellElement, { column: field, value: cell.value, text: cell.text }, "data");
                                if (enableDrawIconSelectRow) {
                                    $("div", e.cellElement).prepend(ReportWidget.linkDrilldown);
                                }
                            }
                        }
                        else {
                            if (enableDrawIconSelectRow && cell.value !== undefined && !isNaN(cell.value)) {
                                e.cellElement.prepend(ReportWidget.linkDrilldown);
                            }

                            let color = field.foreColor;
                            let backgroundColor = field.backgroundColor;

                            if (!e.cellElement.hasClass("fr-row-fontColor-applied")) {
                                e.cellElement.css("color", color);
                                e.cellElement.children().css("color", color);
                            }
                            if (!e.cellElement.hasClass("fr-row-backgroundColor-applied") && backgroundColor && backgroundColor.toLowerCase() !== "#ffffff") {
                                e.cellElement.css("background-color", backgroundColor);
                                e.cellElement.children().css("background-color", backgroundColor);
                            }
                        }

                        if (field.thresholdColor && field.thresholdValue !== undefined && field.thresholdValue !== null && cell.value !== undefined && cell.value < field.thresholdValue) {
                            let color = field.thresholdColor;
                            if (!e.cellElement.hasClass("fr-row-fontColor-applied") && !e.cellElement.hasClass("fr-fontColor-applied")) {
                                e.cellElement.css("color", color);
                                e.cellElement.children().css("color", color);
                            }
                        }

                        if (enableDrawIconSelectRow) {
                            $("a.drilldowrow", e.cellElement).click(function (ev) {
                                if (workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting) {
                                    return;
                                }
                                self.clickDrillDown(e, self.result, e.cellElement, ev);
                            });
                        }

                        let collapseText = cell.rowPath && cell.rowPath.length > 0 ? cell.rowPath[0].toString() : "";
                        if (collapseText && (typeof collapseText === 'string' || collapseText instanceof String) && collapseText.includes("<!--collapse-->")) {
                            e.cellElement.addClass("hideExpandIcon");
                        }
                    }
                }
                else {
                    if (cell.text && (typeof cell.text === 'string' || cell.text instanceof String) && cell.text.includes("<!--collapse-->")) {
                        if (cell.expanded) {
                            collapseRows.push(cell.path);
                        }
                        e.cellElement.addClass("hideExpandIcon");
                    }
                }

                //Metric header
                if (e.area === "column" && cell.dataIndex !== undefined) {
                    let field = PivotWidget.getField(e.component, cell)
                    if (field && field.isMetric) {
                        e.cellElement.css("text-align", field.alignment);
                    }
                }

                //Rows and Columns, without the Metrics
                if (e.area === "row" || (e.area === "column" && cell.dataIndex === undefined)) {
                    let field = PivotWidget.getFieldByArea(e.component, cell);
                    if (field) {
                        e.cellElement.css("text-align", field.groupColumns[0].alignment);
                    }
                }

                if (self.itemConfig.pivotConfig.separateFields()) {
                    if (cell.type === 'T') {
                        e.cellElement.text(replaceBasicHtmlContent(`${self.itemConfig.subTotalText()} ${cell.path[cell.path.length - 1].totalTextSeparateFields}`));
                    }

                    if (cell.type === 'D' && e.area === "row") {
                        let field = PivotWidget.getFieldByArea(e.component, cell);
                        if (field) {
                            if (field.showTotals === false) {
                                e.cellElement.css("font-weight", "normal");
                                e.cellElement.addClass("hideExpandCollapseIcon");
                            }
                        }
                    }
                }

                if (workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting) {
                    e.cellElement.addClass("hideExpandCollapseIcon");
                }
            },
            onCellClick(e) {
                if (workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting) {
                    return;
                }

                if (!self.itemConfig.enableRowSelection()) {
                    self.clickDrillDown(e, self.result, e.element, e.event);
                }
                else if (e.area === 'data') {
                    e.event.stopPropagation();
                    const table = e.cellElement.closest("table");
                    $("tr", table).removeClass("highlight");
                    e.cellElement.closest("tr").addClass("highlight");
                }
            },
            onInitialized: function (e) {
            },
            onContentReady: function (e) {
                //Create a thead and move the header row, so, the header is printed on each page
                if (workbook.workbookConfig.isPrinting) {
                    var mainTable = $(".dx-pivotgrid-container > table", e.element);
                    var headerRow = $("> tr:has(.dx-pivotgrid-horizontal-headers)", mainTable);
                    var thead = $("<thead class='dx-datagrid-headers dx-datagrid-table' style='display: table-header-group; background-color: unset;'></thead>");
                    thead.prepend(headerRow);
                    mainTable.prepend(thead);
                }

                if (self.tabOrWidget.drilldownManager.isDrilldown && self.result.baseColumns && self.result.baseColumns.filter(x => x.name === PivotWidget.emptyGroupName).length > 0) {
                    let thead = $("thead.dx-pivotgrid-horizontal-headers", e.element);
                    thead.closest("table").css("height", "100%");
                    $("tr:first", thead).css("display", "none");
                    $("tr:not(:first) td", thead).css("vertical-align", "middle");
                }

                if (self.itemConfig.glReport()) {
                    if (collapseRows.length > 0) {
                        e.component.collapsedRows = collapseRows.length;
                        e.component.beginUpdate();
                        let dataSource = e.component.getDataSource();
                        collapseRows.forEach(function (rowKey) {
                            dataSource.collapseHeaderItem("row", rowKey);
                        });
                        collapseRows = [];
                        e.component.endUpdate();
                    }
                    else {
                        if (workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting) {
                            //The number of rows we collapse is the number of times onContentReady executes
                            if (e.component.collapsedRows !== undefined && e.component.collapsedRows !== null) {
                                e.component.collapsedRows--;

                                if (e.component.collapsedRows <= 0) {
                                    e.component.isReadyIR = true;
                                }
                            }
                            else {
                                e.component.isReadyIR = true;
                            }
                        }
                    }
                }
                else {
                    if (workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting) {
                        e.component.isReadyIR = true;
                    }
                }

                if (e.component.isReadyIR || (!workbook.workbookConfig.isPrinting && !workbook.workbookConfig.isExcelPrinting)) {
                    if (typeof irngCustom !== 'undefined' && irngCustom?.enableCustomization && irngCustom.onContentReadyPivot) {
                        try {
                            irngCustom.onContentReadyPivot(e, self.itemConfig.glReport(), self.result);
                        }
                        catch (err) {
                            console.log(`Error on irngCustom.onContentReadyPivot: ${err.message}`);
                        }
                    }
                }

                if (firstOnContentReady) {
                    firstOnContentReady = false;
                }
            },
            onContextMenuPreparing: function (e) {
                for (var i = 0; i < e.items.length; i++) {
                    if (e.items[i].text && e.items[i].text.startsWith("Sort")) {
                        e.items[i].visible = false;
                    }
                }

                if (e.items.filter(function (x) { return x.visible !== undefined && !x.visible; }).length === e.items.length) {
                    e.items = [];
                }
            }
        };
    }

    static isDataCell(cell) {
        return (cell.area === 'data' && cell.rowType === 'D' && cell.columnType === 'D');
    }
    
    static isTotalCell(cell) {
        return (cell.type === 'T' || cell.type === 'GT' || cell.rowType === 'T' || cell.rowType === 'GT' || cell.columnType === 'T' || cell.columnType === 'GT');
    }
    
    static getField(component, cell) {
        let field = component.getDataSource().getAreaFields("data")[cell.dataIndex];
        return field;
    }

    static getFieldByArea(component, cell) {
        let fields = component.getDataSource().getAreaFields(cell.area);
        if (cell.path && fields.length >= cell.path.length) {
            return fields[cell.path.length - 1];
        }

        return null;
    }

    private getPivotHeight() {
        if (workbook.workbookConfig.isExcelPrinting)
            return 200;

        return !workbook.workbookConfig.isPrinting && this.itemConfig.enableSearchBox() ? "calc(100% - 26px)" : "100%";
    }

    override setupSettings() {
        super.setupSettings();

        let self = this;
        let setOptionPivotGrid = (widget: IWidget, propertyName: string, value) => {
            let pivotGrid = (widget as PivotWidget).result.pivotGrid;
            pivotGrid.option(propertyName, value);
        }

        this.createSettingItem(this.itemConfig.expandAllRowsPrinting, "expandAllRowsPrinting", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.expandAllRows, "expandAllRows", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.pivotConfig.expandAllColumns, "pivotConfig.expandAllColumns", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.pivotConfig.expandAllColumnsPrinting, "pivotConfig.expandAllColumnsPrinting", UpdateSettingMode.Setup);

        this.createSettingItem(this.itemConfig.pivotLayout, "pivotLayout", UpdateSettingMode.Reload);

        this.createSettingItem(this.itemConfig.pivotConfig.columnFieldsText, "pivotConfig.columnFieldsText", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.pivotConfig.separateFields, "pivotConfig.separateFields", UpdateSettingMode.Setup);

        this.createSettingItem(this.itemConfig.pivotConfig.rowHeaderLayoutPivot, "pivotConfig.rowHeaderLayoutPivot", UpdateSettingMode.Custom, (newValue, widget) => {
            setOptionPivotGrid(widget, "rowHeaderLayout", this.itemConfig.glReport() ? 'standard' : newValue === 0 ? 'tree' : 'standard');
        });

        this.createSettingItem(this.itemConfig.pivotConfig.showColumnGrandTotals, "pivotConfig.showColumnGrandTotals", UpdateSettingMode.Custom, (newValue, widget) => {
            setOptionPivotGrid(widget, "showColumnGrandTotals", newValue);
        });

        this.createSettingItem(this.itemConfig.pivotConfig.showColumnTotals, "pivotConfig.showColumnTotals", UpdateSettingMode.Custom, (newValue, widget) => {
            setOptionPivotGrid(widget, "showColumnTotals", newValue);
        });

        this.createSettingItem(this.itemConfig.pivotConfig.showRowGrandTotals, "pivotConfig.showRowGrandTotals", UpdateSettingMode.Custom, (newValue, widget) => {
            setOptionPivotGrid(widget, "showRowGrandTotals", newValue);
        });

        this.createSettingItem(this.itemConfig.pivotConfig.showRowTotals, "pivotConfig.showRowTotals", UpdateSettingMode.Custom, (newValue, widget) => {
            setOptionPivotGrid(widget, "showRowTotals", newValue);
        });

        this.createSettingItem(this.itemConfig.enableFilterPanel, "enableFilterPanel", UpdateSettingMode.Custom, (newValue, widget) => {
            setOptionPivotGrid(widget, "fieldPanel.visible", newValue);
        });

        this.createSettingItem(this.itemConfig.enableSearchBox, "enableSearchBox", UpdateSettingMode.Custom, (newValue: boolean, widget) => {
            setOptionPivotGrid(widget, "height", self.getPivotHeight())

            let searchBox = (widget as PivotWidget).result.searchBox;
            if (searchBox) {
                searchBox.option("visible", newValue);
            }
        });
    }

    clickDrillDown(e, result, element, event) {
        let self = this;

        if (!self.tabOrWidget.drilldownManager.isDrilldownPossible())
            return;

        //e.handled indicates that it treated by another function, ex. to expand a group
        if (e.handled)
            return;

        let tabValues: Array<FilterValuesVM> = [];

        if (e.area === 'data') {//Drilldown

            const pivotGridDataSource = e.component.getDataSource();
            const drillDownDataSource = pivotGridDataSource.createDrillDownDataSource(e.cell);
            drillDownDataSource.load()
                .done(function (data) {

                    if (data.length === 0) {
                        return;
                    }

                    for (let i = 0; i < result.columns.length; i++) {
                        let column = result.columns[i];
                        if (e.cell.rowType === "GT" && column.area === "row") {
                            continue;
                        }
                        else if (e.cell.columnType === "GT" && column.area === "column") {
                            continue;
                        }

                        if (!column.isMetric && column.isGrouping) {
                            for (let gc = 0; gc < column.groupColumns.length; gc++) {
                                let columnGroup = column.groupColumns[gc];
                                if (!columnGroup.isMetric && columnGroup.groupingType === 4) {
                                    let addFilter = true;
                                    let startCondition = undefined;
                                    for (let di = 0; di < data.length; di++) {
                                        if (startCondition === undefined) {
                                            startCondition = data[di][column.dataField].values[gc]
                                        }
                                        else if (startCondition !== data[di][column.dataField].values[gc]) {
                                            addFilter = false;
                                            break;
                                        }
                                    }

                                    if (addFilter) {
                                        tabValues.push({
                                            name: columnGroup.queryName,
                                            startCondition: startCondition,
                                            isGroupField: columnGroup.isGrouping,
                                        });
                                    }
                                }
                            }
                        }
                    }

                    self.executeDrilldown(tabValues);
                })
                .fail(function (error) {

                });
        }
    }

    override repaint() {
        this.result.pivotGrid.repaint();
    }

    override print() {
        let href = `/Email/Html?scope=Report&mappingId=${this.tab.workbookConfig.mappingId}&workbookId=${this.tab.workbookConfig.workbookId()}&tabId=${this.tab.workbookConfig.activeTab().id()}&print=True&em=False`;
        if (this.isDashboardWidget) {
            href += `&widgetId=${this.dashboardWidget.id()}`;
        }

        window.open(href, "_blank").focus();
    }

    override exportToPDF(isLandscape: boolean, templateId: number) {
        let href = `/Email/Pdf?scope=Report&mappingId=${workbook.workbookConfig.mappingId}&workbookId=${workbook.workbookConfig.workbookId()}&tabId=${workbook.workbookConfig.activeTab().id()}`;
        if (isLandscape) {
            href += `&landscape=${isLandscape}`;
        }

        if (templateId && templateId > 0) {
            href += `&pdfTemplateId=${templateId}`;
        }

        if (this.isDashboardWidget) {
            href += `&widgetId=${this.dashboardWidget.id()}`;
        }

        window.open(href, "_blank").focus();
    }

    override exportToXLSX(withoutHeaders: boolean) {
        workbook.workbookConfig.workbookHelper.exportToXLSXCSV(false, withoutHeaders, workbook.workbookConfig.activeTabOrWidget().getBaseSubmitObject(), (settings) => {
            printExport.exportPivotToExcel(settings, this.result.pivotGrid, this.$reportContent);
        });
    }

    override exportToCSV(withoutHeaders: boolean) {
        workbook.workbookConfig.workbookHelper.exportToXLSXCSV(true, withoutHeaders, workbook.workbookConfig.activeTabOrWidget().getBaseSubmitObject(), (settings) => {
            printExport.exportPivotToExcel(settings, this.result.pivotGrid, this.$reportContent);
        });
    }
}